// extracted by css-extract-rspack-plugin
export default {"Comments":"Comments-p39HIt","comments":"Comments-p39HIt","Comments__item":"Comments__item-Bmu7e5","commentsItem":"Comments__item-Bmu7e5"};